import React,{useState} from "react";
import MiniDrawer,{ DrawerHeader }  from "../shared/components/navigations/side-nav";

const PublicRouter = () => {
   
  return (
    <>
      <div>
     <MiniDrawer/>
       
     {/* <Box component="main" sx={{ flexGrow: 1, p: 1, border:'2px solid rgba(128, 128, 128, .2)'}}>
        <DrawerHeader />
        <Box  sx={{ flexGrow: 1, p: 1, border:'2px solid grey' }}>
        <Outlet/>
        </Box>
      </Box> */}
      </div>
      {/* footer if needed */}
    </>
  );
};

export default PublicRouter;
